import { Outlet, NavLink } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { House, Wallet, Gift, BellRinging } from "@phosphor-icons/react";
import WhatsAppButton from "@/components/app/WhatsAppButton";
import { InstallPWAModal, InstallPWAButton } from "@/components/app/InstallPWA";
import { NotificationBell } from "@/components/app/NotificationBell";
import { Logo } from "@/components/app/Logo";
import { UserMenu } from "@/components/app/UserMenu";
import { Toaster } from "sonner";

const NAV = [
  { to: "/portal", label: "Início", icon: House, end: true },
  { to: "/portal/pagamentos", label: "Pagamentos", icon: Wallet },
  { to: "/portal/beneficios", label: "Benefícios", icon: Gift },
  { to: "/portal/notificacoes", label: "Avisos", icon: BellRinging },
];

const ClientLayout = () => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-zinc-50 to-white text-zinc-900 pb-24">
      <Toaster position="top-center" />
      <InstallPWAModal openOnMount={true} />
      <header className="sticky top-0 z-30 backdrop-blur bg-zinc-950/95 border-b border-zinc-900 pt-[env(safe-area-inset-top)]">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 h-14 flex items-center justify-between">
          <Logo variant="full" height={28} />
          <div className="flex items-center gap-2">
            <InstallPWAButton className="hidden sm:inline-flex" />
            <NotificationBell scope="client" />
            <UserMenu variant="dark" />
          </div>
        </div>
      </header>

      <main className="max-w-3xl mx-auto px-4 sm:px-6 py-6">
        <Outlet />
      </main>

      {/* Bottom nav */}
      <nav className="fixed bottom-0 left-0 right-0 z-30 bg-white/95 backdrop-blur border-t border-zinc-200 pb-[max(0px,env(safe-area-inset-bottom))]">
        <div className="max-w-3xl mx-auto px-2 grid grid-cols-4">
          {NAV.map((it) => (
            <NavLink
              key={it.to}
              to={it.to}
              end={it.end}
              data-testid={`client-nav-${it.to.replace(/\//g, "-")}`}
              className={({ isActive }) =>
                `flex flex-col items-center justify-center py-2.5 text-[11px] gap-1 transition-colors ${
                  isActive ? "text-blue-600" : "text-zinc-500 hover:text-zinc-800"
                }`
              }
            >
              <it.icon size={20} weight="regular"/>
              <span className="font-medium">{it.label}</span>
            </NavLink>
          ))}
        </div>
      </nav>

      <WhatsAppButton />
    </div>
  );
};

export default ClientLayout;
